
import { defineComponent, reactive, toRaw } from 'vue'

// Components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Validation
import useVuelidate from '@vuelidate/core'
import { required, numeric, integer, between } from '@vuelidate/validators'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        receiverIdx: {
            type: Number,
            default: null,
        },
    },
    emits: ['submit'],
    setup(props, { emit }) {
        const state = reactive({
            title: null as string | null,
            price: null as string | null,
            count: null as string | null,
        })

        const rules = {
            title: { required },
            price: { numeric },
            count: { required, integer, between: between(1, 9999) },
        }

        const state_form$ = useVuelidate(rules, state)

        const onSubmit = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            const payload = {
                product: toRaw({
                    title: state.title,
                    price: Number(state.price),
                    count: Number(state.count),
                }),
                index: props.receiverIdx,
            }

            emit('submit', payload)

            state.title = null
            state.price = null
            state.count = null

            state_form$.value.$reset()
        }

        return { state, state_form$, onSubmit }
    },
})
